import { Form, message } from 'antd'
import { useEffect, useMemo, useReducer } from 'react'
import { useCloseTab, usePageCache, useQuery } from '../../tools/utilHooks'
import { useLocation } from 'react-router-dom'
import reducer, {
  changeloadingAction,
  initialState,
  resetStateAction,
  setDockingSalesJobNumber,
  setFillingSheetState,
  setFormDataAction,
  setIsAddModalVisivle,
  setIsSubmitButtonLoadingAction,
  setSearchData,
  setStaffModalVisibleAction,
  setdataAction,
  reloadStateAction,
  setRouteParamsAction,
  setPlatformListAction,
} from './reducer'
import {
  FilingNoDetailRes,
  GET_ORDERNO_FILILING_DETAIL,
  SAVE_ORDERNO_FILING,
  GET_OA_USER_LIST,
  GET_SUPPLIER_PLATFORM_LIST,
  oaUserItem,
} from '../../api/Filing'
import _ from 'lodash'
import { isResponseCodeSuccess } from '../../tools/util'
import { Props } from '.'
import { history, useTypedSelector } from '../../redux/store'
import { setModuleDataAction } from '../../modules/pagecache'
import { useDispatch } from 'react-redux'

export const NOT_EDIT_STATES = [
  '已派单',
  '已撤回',
  '报备中',
  '审核中',
  '已过期',
]
export default function useHook(props?: Props) {
  const [state, dispatch] = useReducer(reducer, initialState)
  const dispatchRedux = useDispatch()
  const { pagekey } = useTypedSelector((state) => state.pageCache)
  const {
    dataSource,
    isAddModalVisivle,
    selectedRowKeys,
    invoiceData,
    formData,
    isSubmitButtonLoading,
    staffModalVisible,
    userListdataSource,
    dockingSalesJobNumber,
    routeParams,
    platformList,
  } = state
  const { state: routeState, pathname } = useLocation<{ id: string }>()
  const query = useQuery()
  // const id = props?.id ?? query.get('id') ?? ''
  const { onCurrentPageClose } = useCloseTab()
  const { closeCurrentTab } = usePageCache()
  const [form] = Form.useForm()
  const isH5Detail = props?.detail

  const getPlatformList = async () => {
    const res = await GET_SUPPLIER_PLATFORM_LIST()
    if (isResponseCodeSuccess(res.code)) {
      dispatch(setPlatformListAction(res.data || []))
      return res.data || []
    }
    return []
  }
  useEffect(() => {
    const initData = async () => {
      const flag = getpagecache()
      if (flag && !routeState) {
        dispatch(reloadStateAction(flag.pageState))
        form.setFieldsValue(flag.formData)
      } else {
        // 先获取平台列表，确保在调用getFilingNoDetail时platformList已经更新
        const currentPlatformList = await getPlatformList()
        dispatch(setRouteParamsAction(routeState))
        if (routeState?.id) {
          getFilingNoDetail(routeState.id, currentPlatformList)
        } else if (props?.id) {
          getFilingNoDetail(props?.id, currentPlatformList)
        }
      }
    }
    initData()
    // eslint-disable-next-line
  }, [])

  // 缓存数据
  const onCache = () => {
    // 缓存存数据
    const pathName = history.location.pathname
    const formData = form.getFieldsValue()
    const action = setModuleDataAction({
      key: pathName,
      data: {
        pageState: state, // 当前状态
        formData: formData,
      },
    })
    dispatchRedux(action)
  }

  useEffect(() => {
    // 缓存存数据
    onCache()
    // eslint-disable-next-line
  }, [state])

  // 获取数据
  const getpagecache = () => {
    const pathName = history.location.pathname
    const data = pagekey.filter((item) => item.key === pathName)
    if (data.length === 1) {
      return data[0].data
    }
    return null
  }
  const isDetailPageMemo = useMemo(() => {
    return isH5Detail || pathname === '/srm/reportReceiptDetail'
  }, [pathname, isH5Detail])
  const isEditDisableMemo = useMemo(() => {
    if (isH5Detail) {
      return true
    }
    if (isDetailPageMemo) {
      if (
        NOT_EDIT_STATES.includes(
          (formData as FilingNoDetailRes)?.state ?? '',
        ) ||
        // 初始为disable状态
        formData?.state === undefined
      ) {
        return true
      }
      return false
    } else {
      return false
    }
  }, [isDetailPageMemo, formData])
  const handleSubmit = async () => {
    const formValues = await form.validateFields()
    let submitParam: any = {
      ..._.pick(formValues, [
        'customer',
        'orderNo',
        'platform',
        'price',
        'remark',
        'dockingSalesId',
        'dockingSalesName',
        'customerMdmCode',
        'crmExists',
      ]),
      dockingSalesJobNumber: dockingSalesJobNumber,
    }
    if (isDetailPageMemo) {
      submitParam = {
        ...submitParam,
        id: routeState.id || routeParams.id,
        dockingSalesJobNumber: dockingSalesJobNumber,
      }
    }
    dispatch(setIsSubmitButtonLoadingAction(true))
    const res = await SAVE_ORDERNO_FILING({
      ...submitParam,
    })
    dispatch(setIsSubmitButtonLoadingAction(false))
    if (isResponseCodeSuccess(res.code)) {
      message.success('操作成功')
      onCurrentPageClose()
    }
  }

  const handleAddOrderModalCancel = () => {
    dispatch(setIsAddModalVisivle(false))
  }

  const handleClosePage = () => {
    closeCurrentTab()
    resetGlobalState()
  }
  const handleFormDataChange = (changedValues: any, allValues: any) => {
    onCache()
    dispatch(
      setFormDataAction({
        ...formData,
        ...allValues,
      }),
    )
  }
  function resetGlobalState() {
    dispatch(resetStateAction())
  }

  async function getFilingNoDetail(id: string, currentPlatformList: any[]) {
    const res = await GET_ORDERNO_FILILING_DETAIL({
      filingId: id || routeParams.id,
    })
    if (isResponseCodeSuccess(res.code)) {
      dispatch(setFormDataAction(res.data))

      // 根据平台code查找平台名称
      const platformCode = res.data.platform
      const platformName = res.data.platformName
      const platformItem = currentPlatformList.find(
        (item: any) => item.platformCode === platformCode,
      )

      // 处理平台字段的值
      let platformValue = platformCode
      let platformNameValue = platformName

      // 编辑模式：如果平台code不在列表中，清空platform字段，让用户重新选择
      if (platformCode && !platformItem) {
        platformValue = ''
        platformNameValue = ''
      }

      form.setFieldsValue({
        ...res.data,
      })
      if (!NOT_EDIT_STATES.includes(res.data.state)) {
        form.setFieldsValue({
          platform: platformValue,
          platformName: platformNameValue, // 存储平台名称，用于显示
        })
      }
      dispatch(setDockingSalesJobNumber(res.data.dockingSalesJobNumber))
      dispatch(
        setFillingSheetState({
          state: res.data.state,
          approvalOpinion: res.data.approvalOpinion || '-',
        }),
      )
    }
  }

  // 对接销售弹框显隐
  const setStaffModalVisible = (val: boolean) => {
    dispatch(
      setdataAction({
        dataSource: {
          data: [],
          loading: false,
        },
      }),
    )
    dispatch(setStaffModalVisibleAction(val))
  }

  // 搜索
  const handleSearchClick = (params: any) => {
    dispatch(setSearchData(params))
    getdata({
      ...state,
      ...{
        searchdata: params,
      },
    })
  }

  // 获取列表数据
  const getdata = async (DeptDataState: any) => {
    if (isH5Detail) {
      return
    }
    const params = { ...DeptDataState.searchdata }
    // 添加loading
    dispatch(changeloadingAction(true))
    const res = await GET_OA_USER_LIST({
      name: params.realName,
      mobile: params.mobile,
    })
    if (isResponseCodeSuccess(res.code)) {
      dispatch(
        setdataAction({
          dataSource: {
            data: res.data,
            loading: false,
          },
        }),
      )
    } else {
      dispatch(changeloadingAction(false))
    }
  }

  // 选中查询的员工数据
  const onClickStaffRow = (record: oaUserItem) => {
    setStaffModalVisible(false)
    const formData = form.getFieldsValue()
    dispatch(setDockingSalesJobNumber(record.jobNumber))
    form.setFieldsValue({
      ...formData,
      dockingSalesName: record.name,
      dockingSalesId: record.dingId,
    })
  }

  return {
    selectedRowKeys,
    dataSource,
    form,
    platformList,
    isAddModalVisivle,
    invoiceData,
    isSubmitButtonLoading,
    handleAddOrderModalCancel,
    handleSubmit,
    handleClosePage,
    handleFormDataChange,
    state,
    isDetailPageMemo,
    isEditDisableMemo,
    staffModalVisible,
    setStaffModalVisible,
    userListdataSource,
    handleSearchClick,
    onClickStaffRow,
    isH5Detail,
  }
}
import { Form, message } from 'antd'
import { useEffect, useMemo, useReducer } from 'react'
import { useCloseTab, usePageCache, useQuery } from '../../tools/utilHooks'
import { useLocation } from 'react-router-dom'
import reducer, {
  changeloadingAction,
  initialState,
  resetStateAction,
  setDockingSalesJobNumber,
  setFillingSheetState,
  setFormDataAction,
  setIsAddModalVisivle,
  setIsSubmitButtonLoadingAction,
  setSearchData,
  setStaffModalVisibleAction,
  setdataAction,
  reloadStateAction,
  setRouteParamsAction,
  setPlatformListAction,
} from './reducer'
import {
  FilingNoDetailRes,
  GET_ORDERNO_FILILING_DETAIL,
  SAVE_ORDERNO_FILING,
  GET_OA_USER_LIST,
  GET_SUPPLIER_PLATFORM_LIST,
  oaUserItem,
} from '../../api/Filing'
import _ from 'lodash'
import { isResponseCodeSuccess } from '../../tools/util'
import { Props } from '.'
import { history, useTypedSelector } from '../../redux/store'
import { setModuleDataAction } from '../../modules/pagecache'
import { useDispatch } from 'react-redux'

export const NOT_EDIT_STATES = [
  '已派单',
  '已撤回',
  '报备中',
  '审核中',
  '已过期',
]
export default function useHook(props?: Props) {
  const [state, dispatch] = useReducer(reducer, initialState)
  const dispatchRedux = useDispatch()
  const { pagekey } = useTypedSelector((state) => state.pageCache)
  const {
    dataSource,
    isAddModalVisivle,
    selectedRowKeys,
    invoiceData,
    formData,
    isSubmitButtonLoading,
    staffModalVisible,
    userListdataSource,
    dockingSalesJobNumber,
    routeParams,
    platformList,
  } = state
  const { state: routeState, pathname } = useLocation<{ id: string }>()
  const query = useQuery()
  // const id = props?.id ?? query.get('id') ?? ''
  const { onCurrentPageClose } = useCloseTab()
  const { closeCurrentTab } = usePageCache()
  const [form] = Form.useForm()
  const isH5Detail = props?.detail

  const getPlatformList = async () => {
    const res = await GET_SUPPLIER_PLATFORM_LIST()
    if (isResponseCodeSuccess(res.code)) {
      dispatch(setPlatformListAction(res.data || []))
      return res.data || []
    }
    return []
  }
  useEffect(() => {
    const initData = async () => {
      const flag = getpagecache()
      if (flag && !routeState) {
        dispatch(reloadStateAction(flag.pageState))
        form.setFieldsValue(flag.formData)
      } else {
        // 先获取平台列表，确保在调用getFilingNoDetail时platformList已经更新
        const currentPlatformList = await getPlatformList()
        dispatch(setRouteParamsAction(routeState))
        if (routeState?.id) {
          getFilingNoDetail(routeState.id, currentPlatformList)
        } else if (props?.id) {
          getFilingNoDetail(props?.id, currentPlatformList)
        }
      }
    }
    initData()
    // eslint-disable-next-line
  }, [])

  // 缓存数据
  const onCache = () => {
    // 缓存存数据
    const pathName = history.location.pathname
    const formData = form.getFieldsValue()
    const action = setModuleDataAction({
      key: pathName,
      data: {
        pageState: state, // 当前状态
        formData: formData,
      },
    })
    dispatchRedux(action)
  }

  useEffect(() => {
    // 缓存存数据
    onCache()
    // eslint-disable-next-line
  }, [state])

  // 获取数据
  const getpagecache = () => {
    const pathName = history.location.pathname
    const data = pagekey.filter((item) => item.key === pathName)
    if (data.length === 1) {
      return data[0].data
    }
    return null
  }
  const isDetailPageMemo = useMemo(() => {
    return isH5Detail || pathname === '/srm/reportReceiptDetail'
  }, [pathname, isH5Detail])
  const isEditDisableMemo = useMemo(() => {
    if (isH5Detail) {
      return true
    }
    if (isDetailPageMemo) {
      if (
        NOT_EDIT_STATES.includes(
          (formData as FilingNoDetailRes)?.state ?? '',
        ) ||
        // 初始为disable状态
        formData?.state === undefined
      ) {
        return true
      }
      return false
    } else {
      return false
    }
  }, [isDetailPageMemo, formData])
  const handleSubmit = async () => {
    const formValues = await form.validateFields()
    let submitParam: any = {
      ..._.pick(formValues, [
        'customer',
        'orderNo',
        'platform',
        'price',
        'remark',
        'dockingSalesId',
        'dockingSalesName',
        'customerMdmCode',
        'crmExists',
      ]),
      dockingSalesJobNumber: dockingSalesJobNumber,
    }
    if (isDetailPageMemo) {
      submitParam = {
        ...submitParam,
        id: routeState.id || routeParams.id,
        dockingSalesJobNumber: dockingSalesJobNumber,
      }
    }
    dispatch(setIsSubmitButtonLoadingAction(true))
    const res = await SAVE_ORDERNO_FILING({
      ...submitParam,
    })
    dispatch(setIsSubmitButtonLoadingAction(false))
    if (isResponseCodeSuccess(res.code)) {
      message.success('操作成功')
      onCurrentPageClose()
    }
  }

  const handleAddOrderModalCancel = () => {
    dispatch(setIsAddModalVisivle(false))
  }

  const handleClosePage = () => {
    closeCurrentTab()
    resetGlobalState()
  }
  const handleFormDataChange = (changedValues: any, allValues: any) => {
    onCache()
    dispatch(
      setFormDataAction({
        ...formData,
        ...allValues,
      }),
    )
  }
  function resetGlobalState() {
    dispatch(resetStateAction())
  }

  async function getFilingNoDetail(id: string, currentPlatformList: any[]) {
    const res = await GET_ORDERNO_FILILING_DETAIL({
      filingId: id || routeParams.id,
    })
    if (isResponseCodeSuccess(res.code)) {
      dispatch(setFormDataAction(res.data))

      // 根据平台code查找平台名称
      const platformCode = res.data.platform
      const platformName = res.data.platformName
      const platformItem = currentPlatformList.find(
        (item: any) => item.platformCode === platformCode,
      )

      // 处理平台字段的值
      let platformValue = platformCode
      let platformNameValue = platformName

      // 编辑模式：如果平台code不在列表中，清空platform字段，让用户重新选择
      if (platformCode && !platformItem) {
        platformValue = ''
        platformNameValue = ''
      }

      form.setFieldsValue({
        ...res.data,
      })
      if (!NOT_EDIT_STATES.includes(res.data.state)) {
        form.setFieldsValue({
          platform: platformValue,
          platformName: platformNameValue, // 存储平台名称，用于显示
        })
      }
      dispatch(setDockingSalesJobNumber(res.data.dockingSalesJobNumber))
      dispatch(
        setFillingSheetState({
          state: res.data.state,
          approvalOpinion: res.data.approvalOpinion || '-',
        }),
      )
    }
  }

  // 对接销售弹框显隐
  const setStaffModalVisible = (val: boolean) => {
    dispatch(
      setdataAction({
        dataSource: {
          data: [],
          loading: false,
        },
      }),
    )
    dispatch(setStaffModalVisibleAction(val))
  }

  // 搜索
  const handleSearchClick = (params: any) => {
    dispatch(setSearchData(params))
    getdata({
      ...state,
      ...{
        searchdata: params,
      },
    })
  }

  // 获取列表数据
  const getdata = async (DeptDataState: any) => {
    if (isH5Detail) {
      return
    }
    const params = { ...DeptDataState.searchdata }
    // 添加loading
    dispatch(changeloadingAction(true))
    const res = await GET_OA_USER_LIST({
      name: params.realName,
      mobile: params.mobile,
    })
    if (isResponseCodeSuccess(res.code)) {
      dispatch(
        setdataAction({
          dataSource: {
            data: res.data,
            loading: false,
          },
        }),
      )
    } else {
      dispatch(changeloadingAction(false))
    }
  }

  // 选中查询的员工数据
  const onClickStaffRow = (record: oaUserItem) => {
    setStaffModalVisible(false)
    const formData = form.getFieldsValue()
    dispatch(setDockingSalesJobNumber(record.jobNumber))
    form.setFieldsValue({
      ...formData,
      dockingSalesName: record.name,
      dockingSalesId: record.dingId,
    })
  }

  return {
    selectedRowKeys,
    dataSource,
    form,
    platformList,
    isAddModalVisivle,
    invoiceData,
    isSubmitButtonLoading,
    handleAddOrderModalCancel,
    handleSubmit,
    handleClosePage,
    handleFormDataChange,
    state,
    isDetailPageMemo,
    isEditDisableMemo,
    staffModalVisible,
    setStaffModalVisible,
    userListdataSource,
    handleSearchClick,
    onClickStaffRow,
    isH5Detail,
  }
}
